import { fabric } from "fabric";

export function useFilters() {
  const include = { brilho: 0, contraste: 0 };
  const includeOutput = { brilho: 0, contraste: 0 };

  function calcRestrictValueForFabric(valor) {
    const valueT = Number(valor);
    return (0.4 * valueT) / 10;
  }

  function revertValuePoint10(value) {
    const valueT = Number(value);
    return (10 * valueT) / 0.4;
  }

  function calcBrilho() {
    includeOutput.brilho = calcRestrictValueForFabric(include.brilho);
  }

  function calcContraste() {
    includeOutput.contraste = calcRestrictValueForFabric(include.contraste);
  }

  function sumOrMinusBrilhance(method) {
    if (method == "+") {
      if (include.brilho < 10) include.brilho += 1;
      if (include.brilho >= 10) include.brilho = 10;
    } else {
      if (include.brilho > 0) include.brilho -= 1;
      if (include.brilho <= 0) include.brilho = 0;
    }
  }

  function sumOrMinusContrast(method) {
    if (method == "+") {
      if (include.contraste < 10) include.contraste += 1;
      if (include.contraste >= 10) include.contraste = 10;
    } else {
      if (include.contraste > 0) include.contraste -= 1;
      if (include.contraste <= 0) include.contraste = 0;
    }
  }

  // `splice` dentro do forEach pulava o filtro seguinte e `delete` deixava
  // buracos na lista: agora a lista é refeita só com os filtros que ficam.
  function removeFiltro(name, itemSelecionado) {
    if (itemSelecionado.filters.length > 0) {
      itemSelecionado.filters = itemSelecionado.filters.filter(
        (item) => item && item.type != name
      );
      itemSelecionado.applyFilters();
    }
  }

  function aplicaFiltro(name, filter, itemSelecionado, updateCanvasFn) {
    removeFiltro(name, itemSelecionado);
    itemSelecionado.filters.push(filter);
    itemSelecionado.applyFilters();
    updateCanvasFn();
  }

  function apagarFiltrosExistentes(itemSelecionado, updateCanvasFn) {
    // Brilho e contraste ficam; os outros filtros saem.
    itemSelecionado.filters = itemSelecionado.filters.filter(
      (item) => item && (item.type == "Contrast" || item.type == "Brightness")
    );
    itemSelecionado.applyFilters();
    updateCanvasFn();
  }

  function iniciaFiltro(name, ignoreRemove, itemSelecionado, updateCanvasFn) {
    if (!ignoreRemove) {
      apagarFiltrosExistentes(itemSelecionado, updateCanvasFn);
    }

    if (name == "Brightness") {
      const filter = new fabric.Image.filters.Brightness({
        brightness: includeOutput.brilho,
      });
      aplicaFiltro("Brightness", filter, itemSelecionado, updateCanvasFn);
    }
    if (name == "Contrast") {
      const filter = new fabric.Image.filters.Contrast({
        contrast: includeOutput.contraste,
      });
      aplicaFiltro(name, filter, itemSelecionado, updateCanvasFn);
    }
    if (name == "Grayscale") {
      aplicaFiltro(
        name,
        new fabric.Image.filters.Grayscale(),
        itemSelecionado,
        updateCanvasFn
      );
    }
    if (name == "Sepia") {
      aplicaFiltro(
        name,
        new fabric.Image.filters.Sepia(),
        itemSelecionado,
        updateCanvasFn
      );
    }
    if (name == "Blur") {
      aplicaFiltro(
        name,
        new fabric.Image.filters.Blur({ blur: 0.1 }),
        itemSelecionado,
        updateCanvasFn
      );
    }
    if (name == "OldTimes") {
      aplicaFiltro(
        name,
        new fabric.Image.filters.Sepia(),
        itemSelecionado,
        updateCanvasFn
      );
      aplicaFiltro(
        name,
        new fabric.Image.filters.Noise({ noise: 70 }),
        itemSelecionado,
        updateCanvasFn
      );
    }
    if (name == "Noise") {
      aplicaFiltro(
        name,
        new fabric.Image.filters.Noise({ noise: 50 }),
        itemSelecionado,
        updateCanvasFn
      );
    }
    if (name == "Convolute") {
      aplicaFiltro(
        name,
        new fabric.Image.filters.Convolute({
          matrix: [0, -1, 0, -1, 5, -1, 0, -1, 0],
        }),
        itemSelecionado,
        updateCanvasFn
      );
    }
    if (name == "Vibrance") {
      aplicaFiltro(
        name,
        new fabric.Image.filters.Vibrance({ vibrance: 1 }),
        itemSelecionado,
        updateCanvasFn
      );
    }
    if (name == "HueRotation") {
      const random = "0." + Math.round(Math.random() * 10);
      aplicaFiltro(
        name,
        new fabric.Image.filters.HueRotation({ rotation: Number(random) }),
        itemSelecionado,
        updateCanvasFn
      );
    }
  }

  function carregaInfosFiltros(itemSelecionado) {
    include.contraste = 0;
    include.brilho = 0;
    const filters = itemSelecionado.filters;
    if (filters && filters.length > 0) {
      filters.forEach((item) => {
        if (item.type == "Contrast") {
          include.contraste = revertValuePoint10(item["contrast"]);
        }
        if (item.type == "Brightness") {
          include.brilho = revertValuePoint10(item["brightness"]);
        }
      });
    }
  }

  return {
    include,
    includeOutput,
    calcBrilho,
    calcContraste,
    sumOrMinusBrilhance,
    sumOrMinusContrast,
    removeFiltro,
    aplicaFiltro,
    apagarFiltrosExistentes,
    iniciaFiltro,
    carregaInfosFiltros,
    calcRestrictValueForFabric,
    revertValuePoint10,
  };
}
